"use client"

import { useState } from "react"
import { usePathname } from "next/navigation"
import { getTeasersForPage } from "../model/teasers"
import { Launcher } from "./Launcher"

type ChatPanelComponent = typeof import("./ChatPanel").default

/** Keep the SDK, Markdown renderer and lead form out of the initial page bundle. */
export function AskAI() {
  const pathname = usePathname()
  const [ChatPanel, setChatPanel] = useState<ChatPanelComponent | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [loadError, setLoadError] = useState(false)

  const open = async () => {
    if (isLoading) return
    if (ChatPanel) {
      setIsOpen(true)
      return
    }
    setIsLoading(true)
    setLoadError(false)
    try {
      const chatModule = await import("./ChatPanel")
      setChatPanel(() => chatModule.default)
      setIsOpen(true)
    } catch {
      setLoadError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {!isOpen && (
        <div className="fixed bottom-5 right-5 z-50 sm:bottom-6 sm:right-6">
          {loadError && (
            <p
              role="alert"
              className="mb-3 max-w-60 rounded-2xl bg-white p-3 text-sm text-slate-700 shadow-lg dark:bg-zinc-900 dark:text-zinc-100"
            >
              Не удалось загрузить чат. Нажмите ещё раз, чтобы повторить.
            </p>
          )}
          <Launcher
            teasers={getTeasersForPage(pathname)}
            onOpen={open}
            isLoading={isLoading}
          />
        </div>
      )}
      {/* Keep the conversation mounted when minimized, including active streams. */}
      {ChatPanel && <ChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />}
    </>
  )
}

export default AskAI
